import "./config/i18n";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@xplatform/design-system/styles.css";
import "./index.scss";
import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { injectStylesheet } from '@utils/injectStyles';
import DoctypePage from "@pages/DoctypePage/DoctypePage";
import ExtractionPage from "@pages/ExtractionPage/ExtractionPage";
import { ApplicationProvider } from './ContextProvider';
import { LoadingScreen, XPlatformProvider } from '@xplatform/design-system';

const PORTAL_ID = 'extraction-portal-root';

// Kick off the module's own stylesheet load at module-evaluation time so it
// races with React init. First render is then gated on `cssPromise` via
// Suspense-throw — the host's <Suspense fallback> covers the wait, which
// avoids a flash of un-themed content on first load inside the shell.
let cssStatus: "pending" | "ready" = "pending";
const cssPromise = injectStylesheet(
    `${import.meta.env.BASE_URL || "/"}assets/style.css`,
).then(() => {
    cssStatus = "ready";
});

function useModuleStylesheet() {
    if (cssStatus === "pending") throw cssPromise;
}

const ExtractionApp = () => {
    useModuleStylesheet();

    return (
        <XPlatformProvider>
            <ApplicationProvider>
                <Suspense fallback={<LoadingScreen message="Loading..." />}>
                    <Routes>
                        <Route
                            path="/:doctypeCode"
                            element={
                                <div className="intelligence-extraction-container">
                                    <ExtractionPage />
                                </div>
                            }
                        />
                        <Route
                            path="/"
                            element={
                                <div className="intelligence-extraction-container">
                                    <DoctypePage />
                                </div>
                            }
                        />
                    </Routes>
                </Suspense>
            </ApplicationProvider>
            <div
                id={PORTAL_ID}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                    zIndex: 9999,
                }}
            />
        </XPlatformProvider>
    );
};

export default ExtractionApp;
